import { ScriptSchemaType } from './product-final.schema';

export const initialScript: ScriptSchemaType = {
  id: Date.now(),
  name: '',
  productId: 1,
  resources: [],
  stages: [],
  materials: [],
  products: [],
  items: [],
};

export const initialProductFinal = {
  name: '',
  norm: '',
  quantity: undefined,
  scripts: [initialScript],
}; 